import {Component, OnInit, HostListener, ViewChild} from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter} from '../../@theme/pipes/dateFormatPicker';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { LocalDataSource } from 'ng2-smart-table';

@Component({
  selector: 'ngx-admin-bajaSocial',
  templateUrl: './admin-bajaSocial.component.html',
  styleUrls: ['./admin-bajaSocial.component.scss'],
  providers: [UtilidadesService,PeticionesHttpBackEndService,NgbModalConfig, NgbModal,{provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}]
})
export class AdminBajaSocialComponent implements OnInit {
 
  Token: any;
  openModal:any;
  usuario:any;
  listBajaUsuario:any;
  usuarioSeleccionado:any;
  settings = {
    mode: 'inline',
    sort: true,
    noDataMessage: "No se han encontrado resultados.",
    actions: {
      columnTitle: "Acciones",
      add: false,
      edit: false,
      custom: [
        { name: 'edit', title: '<i class="nb-checkmark"></i>' },
      ],
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-close"></i>',
      confirmDelete: true,
    },
    columns: {
      Nombre: {
        title: 'Nombre de usuario',
        type: 'string',
        filter: true
      },
      Motivos: {
        title: 'Motivos',
        type: 'string',
        filter: true
      },
      FechaSolicitada: {
        title: 'FechaSolicitada',
        type: 'string',
        filter: false,
        valuePrepareFunction: (date) => {
					if (date) {
						return this.datepip.transform(date, "dd-MM-yyyy - HH:mm:ss");
					}
				}
      }
    },
  };
  source: LocalDataSource = new LocalDataSource();
  constructor(private datepip: DatePipe,private _route: ActivatedRoute, private utilidades: UtilidadesService,config: NgbModalConfig, private modalService: NgbModal, private _http : PeticionesHttpBackEndService, private DatePipe: DatePipe,public fb: FormBuilder,private router: Router) { 
    this.Token = JSON.parse(localStorage.getItem('auth_app_token'));
    config.backdrop = 'static';
    config.keyboard = false;
    this.listBajaUsuario = [];
    this.usuarioSeleccionado = "";
  }

  ngOnInit() {
    this._http.getUsuario().subscribe(
      result => {
        this.usuario = result;
        if(this.usuario.Entidad._rol_id !== 1){
          this.router.navigate(['auth/login']);
        }else{
          this._http.getOneReg("v1/getUsuariosBajaSocial",this.usuario.Entidad._entidad_id).subscribe(
            result => {
              let resultado:any = result;
              if(resultado.Code == 250){
                this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
              }else{
                for (let baja of resultado.BajasExtensionesSociales) {
                  this.listBajaUsuario.push({EntidadId:baja._entidad_id._entidad_id,Nombre:baja._entidad_id._nombre+" "+(baja._entidad_id._apellidos !== undefined ? baja._entidad_id._apellidos : ""),Motivos:baja._motivo_baja,FechaSolicitada:baja._fecha_solicitada});
                }
                this.source.load(this.listBajaUsuario);
              }
            });
        }
      }
    );
  }

onCustomAction(event,modalBajaUsuario) {
  if(event.action=="edit"){
    this.onRowSelect(event,modalBajaUsuario);
  }    
}

onDeleteConfirm(event,modalCancelarBajaUsuario): void {
  this.usuarioSeleccionado = "";
  this.usuarioSeleccionado = event.data;
  this.openModal = this.modalService.open(modalCancelarBajaUsuario);
}

onRowSelect(event,modalBajaUsuario): void {
    this.usuarioSeleccionado = "";
    this.usuarioSeleccionado = event.data;
    this.openModal = this.modalService.open(modalBajaUsuario);
}

bajaUsuarioClick(){
  this._http.insertaObjecto("v1/bajaUsuarioSocial",{Data: {"entidadId":this.usuario.Entidad._entidad_id,"entidadBaja":this.usuarioSeleccionado.EntidadId}}).subscribe(
    result => {
      let resultado :any = result;
      if(resultado.Code == 200){
        this.openModal.close();
        this.listBajaUsuario = [];
        for (let baja of resultado.BajasExtensionesSociales) {
          this.listBajaUsuario.push({EntidadId:baja._entidad_id._entidad_id,Nombre:baja._entidad_id._nombre+" "+(baja._entidad_id._apellidos !== undefined ? baja._entidad_id._apellidos : ""),Motivos:baja._motivo_baja,FechaSolicitada:baja._fecha_solicitada});
        }
        this.source.load(this.listBajaUsuario);
        this.utilidades.notificationSuccess("Aviso",resultado.Mensaje,"top-left");
      }else{
        this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
      }
    },
    error => {
    }
  );

}

cancelarBajaUsuarioClick(){
  this._http.insertaObjecto("v1/cancelarBajaUsuario",{Data: {"entidadId":this.usuario.Entidad._entidad_id,"entidadBaja":this.usuarioSeleccionado.EntidadId}}).subscribe(
        result => {
          let resultado :any = result;
          if(resultado.Code == 200){
            this.openModal.close();
            this.listBajaUsuario = [];
            for (let baja of resultado.BajasExtensionesSociales) {
              this.listBajaUsuario.push({EntidadId:baja._entidad_id._entidad_id,Nombre:baja._entidad_id._nombre+" "+(baja._entidad_id._apellidos !== undefined ? baja._entidad_id._apellidos : ""),Motivos:baja._motivo_baja,FechaSolicitada:baja._fecha_solicitada});
            }
            this.source.load(this.listBajaUsuario);
            this.utilidades.notificationSuccess("Aviso",resultado.Mensaje,"top-left");
          }else{
            this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
          }
        },
        error => {
        }
      );
}
  
}
